// eslint-disable-next-line max-statements
export function calc(imgs, aW) {
  const referenceWidth = aW || screen.width
  let desiredHeight = 330
  if (referenceWidth < 600) desiredHeight = 150
  else if (referenceWidth < 900) desiredHeight = 256
  else if (referenceWidth < 1280) desiredHeight = 300
  aW -= 12

  let row = []
  let use = 0
  let id = 0, y = 0
  for (const i of imgs) {
    i.width = (i.originalWidth * desiredHeight) / i.originalHeight
    i.height = desiredHeight

    row[id] = i
    use += i.width

    if (use >= aW) {
      let exceded = aW - use
      let x
      for (x = y; x < row.length; x++) {
        let percent = row[x].width / use
        let decrease = exceded * percent
        let width = (row[x].width + decrease)
        let height = (row[x].height * width) / row[x].width
        row[x].width = width - 8
        row[x].height = height
      }
      y = x
      use = 0
    }

    id++
  }

}
